export const NOTIFICATION_STATUSES = {
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  FAILED: "Failed",
  CANCELED: "Canceled"
};

export const STEP_STATUS = {
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  FAILED: "failed",
  SKIPPED: "skipped",
  CANCELED: "canceled",
  NOT_STARTED: null
};

export const NOTIFICATION_TYPES = {
  PREVIEW: "Preview",
  BUILD: "Build",
  PUBLISH: "Deployment"
};
